/* Americanflat — prefetch internal page links on intent (hover / touchstart) so
   between-page navigation feels near-instant. Deliberately conservative:
     - same-origin document links only
     - skips cart / checkout / account / admin / orders / search / logout
     - skips download links and target=_blank
     - one prefetch per URL, current page excluded
     - honors Save-Data and slow (2g) connections
     - no-ops when the browser doesn't support <link rel="prefetch">
   ~65ms hover delay (so links merely brushed over aren't fetched), immediate on
   touch (a tap is high intent). */
(function () {
  var conn = navigator.connection;
  if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) return;

  var probe = document.createElement('link');
  if (!probe.relList || !probe.relList.supports || !probe.relList.supports('prefetch')) return;

  var done = {};
  // Pages that are auth-gated, side-effectful, or not worth prefetching.
  var SKIP = /\/(cart|checkout|account|admin|orders|challenge|password|search|apps)(\/|\?|$)/i;
  var hoverTimer;

  function targetUrl(el) {
    var a = el && el.closest ? el.closest('a[href]') : null;
    if (!a || !a.href || a.origin !== location.origin) return null;
    if (a.hasAttribute('download') || a.target === '_blank') return null;
    if (SKIP.test(a.pathname + a.search)) return null;
    var url = a.href.split('#')[0];
    if (!url || url === location.href.split('#')[0] || done[url]) return null;
    return url;
  }

  function prefetch(url) {
    if (done[url]) return;
    done[url] = true;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.as = 'document';
    l.href = url;
    document.head.appendChild(l);
  }

  document.addEventListener('mouseover', function (e) {
    var url = targetUrl(e.target);
    if (!url) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () { prefetch(url); }, 65);
  }, { capture: true, passive: true });

  document.addEventListener('mouseout', function () { clearTimeout(hoverTimer); }, { capture: true, passive: true });

  document.addEventListener('touchstart', function (e) {
    var url = targetUrl(e.target);
    if (url) prefetch(url);
  }, { capture: true, passive: true });
})();
